import getAPIResponse from "Shared/Utils/Domain/Services/GetAPIResponsePrivateService";
import { User } from "../Model/User";

export async function createUser(data) {
	let response = await getAPIResponse("/v1/user", data, "POST");
	if (response === null) {
		return null;
	}
	let user = User.createFromResponseData(response);
	return user;
}